import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import "./Navbar.css";
import {FaBars,FaTimes} from "react-icons/fa";

function Navbar() {
  const [click,setClick] = useState(false);
  const handleClick = () =>  {
    window.innerWidth<1040 ?setClick(!click):setClick(click)
  };

  const [color,setColor] = useState(false);
  const changeColor = () => (window.scrollY >=100)?setColor(true):setColor(false);
  window.addEventListener("scroll",changeColor);
  
  return (
    <div className={color?"header header-bg":"header"}>
      <Link to="/"><h1>Shyam Khade</h1></Link>
       <ul className={click?"nav-menu active":"nav-menu"} >
        <li onClick={()=>handleClick()}><Link to="/">Home</Link></li>
        <li onClick={()=>handleClick()}><Link to="/projects">Projects</Link></li> 
        <li onClick={()=>handleClick()}><Link to="/about">About</Link></li>
        <li onClick={()=>handleClick()}><Link to="/pricing">Pricing</Link></li>
        <li onClick={()=>handleClick()}><Link to="/contact">Contact</Link></li>
      </ul>

      <div className="hamburger" onClick={()=>handleClick()}>
        {click?<FaTimes size={20} style={{color:"#fff"}} />:<FaBars size={20} style={{color:"#fff"}} />}
      </div>
    </div>
  )
}

export default Navbar;
